import { Component, OnInit, ChangeDetectionStrategy } from "@angular/core";
import { ContentHeaderKey } from "src/app/constants/content-header";
import { DirectDepositModel } from "src/app/models/payroll";
import { PayrollService } from "src/app/services/payroll.service";

@Component({
    selector: 'mwp-direct-deposit',
    templateUrl: './direct-deposit.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class PayrollDirectDepositComponent implements OnInit {
    public apiUrl = ContentHeaderKey.PayrollDirectDeposit;
    public currentDirectDeposit: DirectDepositModel;
    public changeRequestDirectDeposit: DirectDepositModel;

    public isEditing: boolean;

    constructor(
        private payrollService: PayrollService,
    ) { }

    ngOnInit(): void {
        this.payrollService.getCurrentDirectDeposit().subscribe((response: DirectDepositModel) => {
            this.currentDirectDeposit = response;
        });
    }

    public newDirectDeposit(): void {
        this.isEditing = true;
        this.changeRequestDirectDeposit = new DirectDepositModel();
    }

    public cancelEdit(event: DirectDepositModel): void {
        if (event)
            this.currentDirectDeposit = event;
        this.isEditing = false;
    }
}
